import { ElevatorControlPanelProps } from "../../ElevatorControlPanel";
import { ElevatorButton } from "../ElevatorButton";
import { ElevatorStandardNumber } from "../ElevatorPanelNumber";
// eslint-disable-next-line import/order
import { EstateComplexLevel } from "@1games-ru/region-shared/dist/enums/estate/estate";

export function ElevatorStandardButtons({
  floors,
  targetFloor,
  currentFloor,
  onTargetFloorChange,
}: Omit<ElevatorControlPanelProps, "size">) {
  return floors.map((floor) => {
    return (
      <ElevatorButton
        key={floor}
        variant={EstateComplexLevel.Standard}
        isActive={floor === targetFloor || floor === currentFloor}
        onClick={() => onTargetFloorChange(floor)}
      >
        <ElevatorStandardNumber value={floor} isActive={floor === targetFloor} />
      </ElevatorButton>
    );
  });
}
